<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <div style="float:right">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">
          <span class="username">{{admin.username}}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>

          <el-dropdown-item divided>
            <span @click="editUser" style="display:block;">编辑</span>
          </el-dropdown-item>

          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="'编辑用户'" :visible.sync="dialogVisible" width="40%">
      <el-form :model="admin" label-width="150px" size="small">
        <el-form-item label="帐号：">
          <el-input v-model="admin.username" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="昵称：">
          <el-input v-model="admin.nickname" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="手机：">
          <el-input v-model="admin.mobile" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="admin.email" style="width: 250px"></el-input>
        </el-form-item>
        <el-form-item label="密码：">
          <el-input v-model="admin.password" type="text" class="input_disc" style="width: 250px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {updateUserInfo} from '@/api2/user'
import { setToken } from '@/utils/auth'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      dialogVisible: false,
      admin:{
        methodCode: 'v1.account.update',
        password:'',
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
    ])
  },
  created(){
    this.admin.username = this.$store.state.user.userInfo.username
    this.admin.nickname = this.$store.state.user.userInfo.nickname
    this.admin.mobile = this.$store.state.user.userInfo.mobile
    this.admin.email = this.$store.state.user.userInfo.email
    this.admin.password = this.$store.state.user.userInfo.password
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    // 退出登录
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },

    //编辑
    editUser() {
      this.dialogVisible = true;
    },
    
    //确定编辑
    handleDialogConfirm(){
      delete this.admin.id
      delete this.admin.token
      this.admin.methodCode = 'v1.account.update'
      updateUserInfo(this.admin).then((res) =>{
        this.dialogVisible = false;
        let tokenStr = res.data.token
        setToken(tokenStr)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 80px;
  line-height: 80px;
  border: none !important;

  .hamburger-container {
    line-height: 90px;
    height: 80px;
    float: left;
    padding: 0 10px;
  }

  .avatar-container {
    width: 200px;
    height: 80px;
    display: inline-block;
    position: absolute;
    text-align: right;
    right: 35px;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      .user-avatar {
        width: 32px;
        height: 32px;
        vertical-align: middle;
        border-radius: 32px;
      }
      .username{
        margin-left: 9px;
        margin-right: 6px;
        font-size: 14px;
        color: #2E3033;
      }
      .el-icon-caret-bottom {
        font-size: 14px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue